import { LinkContainer } from 'react-router-bootstrap';
import { PersonPlusFill, BookFill, ShieldFill, ChatTextFill, ChevronRight } from 'react-bootstrap-icons';
import { SidebarWidget } from './SidebarWidget/SidebarWidget';

const links = [
    { icon: <PersonPlusFill />, text: 'Create Account',    href: '/register' },
    { icon: <BookFill />,       text: 'Gameplay Guide',    href: '/guide' },
    { icon: <ShieldFill />,     text: 'Game Rules',         href: '/rules' },
    { icon: <ChatTextFill />,   text: 'Support Ticket',    href: '/createticket' },
];

export function UsefulLinks() {
    return (
        <SidebarWidget title="Quick Links">
            {links.map(({ icon, text, href }) => (
                <LinkContainer key={href} exact to={href}>
                    <div className="sw-nav-item">
                        <span className="sw-nav-icon">{icon}</span>
                        <span className="sw-nav-text">{text}</span>
                        <ChevronRight className="sw-nav-arrow" />
                    </div>
                </LinkContainer>
            ))}
        </SidebarWidget>
    );
}
